// components
import {
  StyledBoxFlexCenterWrapFullWidth,
  StyledBoxFlexColumnSmallGapHalfWidth,
  StyledFlexGrowBox
} from 'components/shared/Box/Box.styles';

// enums
import { SpecialLeaveWeekEnums } from './SpecialLeaveTab.enums';

// hooks
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

// styles
import {
  StyledControlledToggleButtonGroup,
  StyledHalfWidthTypography,
  StyledTitleTypography
} from './SpecialLeaveFields.styles';

// types
import { FormValues } from './SpecialLeaveTab.types';
import { ScopeSectionProps } from './SpecialLeaveFields.types';

const ScopeSection = ({ isEditable = false }: ScopeSectionProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.specialLeave.settings'
  });
  const { control } = useFormContext<FormValues>();
  return (
    <>
      <StyledTitleTypography variant="h6">
        {t('scope.title')}
      </StyledTitleTypography>
      <StyledBoxFlexColumnSmallGapHalfWidth>
        <StyledBoxFlexCenterWrapFullWidth>
          <StyledHalfWidthTypography variant="body1">
            {t('scope.weekOrWorkingDays')}
          </StyledHalfWidthTypography>
          <StyledFlexGrowBox>
            <StyledControlledToggleButtonGroup
              control={control}
              name="specialLeaveWeekType"
              color="secondary"
              disabled={!isEditable}
              inputToggleButtons={[
                {
                  label: t('scope.week'),
                  value: SpecialLeaveWeekEnums.ALL_DAYS
                },
                {
                  label: t('scope.workingDays'),
                  value: SpecialLeaveWeekEnums.WORKING_DAYS
                }
              ]}
            />
          </StyledFlexGrowBox>
        </StyledBoxFlexCenterWrapFullWidth>
      </StyledBoxFlexColumnSmallGapHalfWidth>
    </>
  );
};

export default ScopeSection;
